let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gMaWy")).then(() => parcelRequire('1QTjA'));